import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var AdvocateTimeLineEntry = t.keyof({
  TimelineEntryAdvancedLevel: null,
  TimelineEntryIntroQuestionsAnswered: null,
  TimelineEntrySalesforceAppExchangeReview: null,
  TimelineEntryBlogComment: null,
  TimelineEntryLinkedInProductRecommended: null,
  CustomEventTimelineEntry: null,
  TimelineEntryBlogCommentDisqus: null,
  TimelineEntryManuallyLoggedActivity: null,
  TimelineEntryPointsExpired: null,
  TimelineEntryPostedATopic: null,
  TimelineEntryAdvocateCheckedInToLocation: null,
  TimelineEntryProspectFormSubmitted: null,
  TimelineEntryCommentedOnAReply: null,
  TimelineEntryRepliedToATopic: null,
  TimelineEntryBlogCommentManual: null,
  TimelineEntryAdvocateSuggestUrl: null,
  TimelineEntryCustomerRelationshipValueUpdated: null,
  TimelineEntryEarnedBadge: null,
  TimelineEntryDonationsRefunded: null,
  TimelineEntryGetAppReview: null,
  TimelineEntryDonationSubmitted: null
});
var CompletedStageTimeLineEntry = t.keyof({
  TimelineEntryAdvocateWorkflow: null,
  TimelineEntryAnsweredCorrectly: null,
  TimelineEntryAnsweredIncorrectly: null,
  TimelineEntryCompletedOnlineAction: null,
  TimelineEntryCompletedReview: null,
  TimelineEntryFileUploaded: null,
  TimelineEntryFollowedOnTwitter: null,
  TimelineEntryImageUploaded: null,
  TimelineEntryLeftAComment: null,
  TimelineEntryLiked: null,
  TimelineEntryPostShared: null,
  TimelineEntryPostSharedOnFacebook: null,
  TimelineEntryPostSharedOnLinkedIn: null,
  TimelineEntryQuestionsAnswered: null,
  TimelineEntryRepliedOnTweet: null,
  TimelineEntryRetweeted: null,
  TimelineEntrySocialSharesSubmitted: null,
  TimelineEntryTweeted: null,
  TimelineEntryVideoUploaded: null
});
var ActivityBase = t.type({
  id: t.string,
  description: t.string,
  createdAt: t.string,
  pointsEarned: nullable(t.number)
});
var Challenge = t.type({
  id: t.string,
  headline: t.string
});
export var StageActivity = t.intersection([ActivityBase, t.type({
  __typename: CompletedStageTimeLineEntry,
  challenge: nullable(Challenge)
})]);
export var ChallengeActivity = t.intersection([ActivityBase, t.type({
  __typename: t.literal('TimelineEntryCompletedChallenge'),
  challenge: Challenge
})]);
export var Activity = t.union([t.intersection([ActivityBase, t.type({
  __typename: AdvocateTimeLineEntry
})]), ChallengeActivity, StageActivity], 'Activity');
export var ProfileActivitiesQuery = t.type({
  member: t.type({
    id: t.string,
    name: t.string,
    recentActivity: nullable(t.type({
      pageInfo: t.type({
        hasNextPage: t["boolean"],
        endCursor: t.string
      }),
      edges: nullable(t.array(t.type({
        cursor: t.string,
        node: nullable(Activity)
      })))
    }))
  })
});
export var ProfileActivityFeedBlockConfig = S.struct({
  typename: S.literal('ProfileActivityFeedBlock'),
  id: S.string,
  hash: S.string,
  memberId: S.string
});